/* eslint-disable no-console */
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { NanoSql } from './nanosql';
import '@angular/compiler';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_PROVIDERS } from './app/app.providers';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { provideIonicAngular, IonicRouteStrategy, isPlatform } from '@ionic/angular/standalone';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { settings } from './settings';
import { provideTranslateService } from '@ngx-translate/core';
import { provideMarkdown } from 'ngx-markdown';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { RegobsApiModuleWithConfig } from './app/modules/common-regobs-api';
import { AppComponent } from './app/app.component';
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { routes } from './app/app.routes';
import { Requestor, StorageBackend } from '@openid/appauth';
import { storageFactory } from './app/modules/auth/factories/storage-factory';
import { httpFactory } from './app/modules/auth/factories/http-factory';
import { AuthService, Browser, DefaultBrowser } from 'ionic-appauth';
import { CapacitorBrowser } from 'ionic-appauth/lib/capacitor';
import { authFactory } from './app/modules/auth/factories/auth-factory';
import { register as registerSwiperWebComponents } from 'swiper/element/bundle';
import { mapOldParamsToNew } from './app/core/services/search-criteria/url-params';
import { icons, registerIconLibrary } from 'nve-designsystem/registerIcons/systemLibraryCustomization.js';

if (environment.production) {
  enableProdMode();
}

function replaceOldParamsWithNew() {
  console.log('rewrite old regobs.no query paramters');
  try {
    const url = new URL(window.location.href);
    mapOldParamsToNew(url.searchParams);
    history.replaceState(null, '', url);
  } catch (error) {
    console.error('Got error when rewriting old params');
    console.error(error);
  }
}

// fordi vi overstyrer Shoelace sine system-ikoner i NVE designsystem må vi registrere disse ikonene manuelt
function registerNveDesignsystemIcons() {
  registerIconLibrary('system', {
    resolver: (name) => {
      return `data:image/svg+xml,${encodeURIComponent(icons[name])}`;
    },
  });
}

function startApp() {
  registerSwiperWebComponents();
  registerNveDesignsystemIcons();
  replaceOldParamsWithNew();

  console.log('starting app');
  bootstrapApplication(AppComponent, {
    providers: [
      // Debug-mode for å sjekke at applikasjonen oppdateres på en zoneless-kompatibel måte
      // https://angular.dev/guide/zoneless#debug-mode-check-to-ensure-updates-are-detected
      // provideCheckNoChangesConfig({ exhaustive: true, interval: 100 }),

      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      // TODO: Gjør det mulig å aktivere deaktivere ios mode via en knapp i headeren hvis på appMode er test
      provideIonicAngular({ useSetInputAPI: true }), // mode: 'ios'

      // Auth related - kan evt flyttes til egen fil eller i APP_PROVIDERS
      {
        provide: StorageBackend,
        useFactory: storageFactory,
      },
      {
        provide: Requestor,
        useFactory: httpFactory,
      },
      {
        provide: Browser,
        useClass: isPlatform('hybrid') ? CapacitorBrowser : DefaultBrowser,
      },
      {
        provide: AuthService,
        useFactory: authFactory,
      },

      // TranslateService har noe initialisering i app.providers.ts
      provideTranslateService(),

      importProvidersFrom(
        BrowserModule,
        FormsModule,
        IonicStorageModule.forRoot({
          driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB],
          storeName: settings.db.nanoSql.dbName,
        }),
        AngularSvgIconModule.forRoot(),
        LeafletModule,

        // This module is auto generated using ng-swagger-gen
        RegobsApiModuleWithConfig.forRoot()
      ),

      provideMarkdown(),

      // Prøvde å legge til withPreloading(PreloadAllModules) men da kræsjet applikasjonen
      // TODO: Prøv igjen etter vi har rydda opp, fjerna alle moduler.
      provideRouter(routes, withComponentInputBinding()),

      provideHttpClient(withInterceptorsFromDi()),
      ...APP_PROVIDERS,
      provideAnimations(),
    ],
  }).catch((err) => console.log(err));
}

document.addEventListener(typeof cordova !== 'undefined' ? 'deviceready' : 'DOMContentLoaded', async () => {
  console.log('Init NanoSql database');
  try {
    await NanoSql.init();
    startApp();
  } catch (err) {
    console.error('Error init NanoSql database', err);
    startApp(); // Try to start app anyway
  }
});
